var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyScanIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.8,
    height: 44.8,
    rx: 22.4,
    fill: "#0057FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1996 33.1999C13.9996 33.1999 13.0446 32.7349 12.3346 31.8049C11.6246 30.8749 11.4196 29.8399 11.7196 28.6999L13.8796 20.5399C13.2196 20.1199 12.6746 19.5499 12.2446 18.8299C11.8146 18.1099 11.5996 17.2999 11.5996 16.3999C11.5996 15.0799 12.0696 13.9499 13.0096 13.0099C13.9496 12.0699 15.0796 11.5999 16.3996 11.5999H25.9996C26.8996 11.5999 27.5796 11.9799 28.0396 12.7399C28.4996 13.4999 28.5296 14.2799 28.1296 15.0799L25.7296 19.8799C25.5096 20.2799 25.2146 20.5999 24.8446 20.8399C24.4746 21.0799 24.0596 21.1999 23.5996 21.1999H21.1696L20.8396 22.3999H21.1996C21.5396 22.3999 21.8246 22.5149 22.0546 22.7449C22.2846 22.9749 22.3996 23.2599 22.3996 23.5999V25.9999C22.3996 26.3399 22.2846 26.6249 22.0546 26.8549C21.8246 27.0849 21.5396 27.1999 21.1996 27.1999H19.5796L18.6796 30.5599C18.4596 31.3399 18.0296 31.9749 17.3896 32.4649C16.7496 32.9549 16.0196 33.1999 15.1996 33.1999ZM30.7996 13.9999L30.0496 12.3799L34.3996 10.3999L35.1196 12.0499L30.7996 13.9999ZM34.3996 22.3999L30.0496 20.4499L30.7996 18.7999L35.1196 20.7799L34.3996 22.3999ZM30.7996 17.2999V15.4999H35.5996V17.2999H30.7996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyScanIn);
export default __webpack_public_path__ + "static/media/EasyScanIn.7f8d6a7b01a4386efbab2078f2952533.svg";
export { ForwardRef as ReactComponent };